// src/Home.js

import React, { useEffect } from "react";
import "./ConfigurationDashboard.css";
import { useNavigate } from "react-router-dom";
import useSessionStorage from "./useSessionStorage";

import useAxios from "./useAxios";

import settingsIcon from "./images/settings.png";

const Tile = ({ title, image, onclick }) => (
  <a onClick={onclick}>
    <div className="tile">
      <h3>{title}</h3>
      <img src={image} alt={title}></img>
    </div>
  </a>
);

const ConfigurationDashboard = ({ logout }) => {
  const navigate = useNavigate();
  const [axios] = useAxios(true, logout);

  const [tenant] = useSessionStorage("tenant");

  useEffect(() => {}, []);

  const handleObsDownload = () => {
    window.location.href = "/downloads/ObsServiceV1.zip";
  };

  return (
    <div className="home-container">
      <div className="home-container-group">
        <Tile
          title="Players"
          image="/images/player.png"
          onclick={() => navigate("/configuration/players")}
        />
        <Tile
          title="Tables"
          image="/images/8ball.png"
          onclick={() => navigate("/configuration/tables")}
        />
        <Tile
          title="Matches"
          image="/images/match.png"
          onclick={() => navigate("/configuration/matches")}
        />
        <Tile
          title="Products"
          image="/images/products.png"
          onclick={() => navigate("/configuration/products")}
        />
        {tenant.super ? (
          <Tile
            title="Tenants"
            image={settingsIcon}
            onclick={() => navigate("/configuration/tenants")}
          />
        ) : null}
        <Tile
          title="Users"
          image={settingsIcon}
          onclick={() => navigate("/configuration/users")}
        />
        <Tile
          title="Stream Types"
          image={settingsIcon}
          onclick={() => navigate("/configuration/streamtypes")}
        />
        <Tile
          title="OBS Service"
          image={settingsIcon}
          onclick={handleObsDownload}
        />
      </div>
    </div>
  );
};

export default ConfigurationDashboard;
